import { CommonModule } from '@angular/common';
import {
  Component,
  OnInit,
  Input,
  TemplateRef,
  ChangeDetectorRef,
  Output,
  EventEmitter,
} from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { RxRoleGuardDirective } from '@org/rx-directives';
import { RxIconComponent } from '../../rx-icon/rx-icon.component';
import { RxRowModule } from '@nrwl/rx-row';
import { CdkDrag, CdkDragHandle, CdkDragPreview, CdkDropListGroup } from '@angular/cdk/drag-drop';

@Component({
  selector: 'rx-list-capture-item',
  templateUrl: './rx-list-capture-item.component.html',
  styleUrls: ['./rx-list-capture-item.component.scss'],
  imports: [
    CommonModule,
    FormsModule,
    MatIconModule,
    MatMenuModule,
    MatCheckboxModule,
    RxRowModule,
    RxIconComponent,
    CdkDropListGroup,
    CdkDrag,
    CdkDragPreview,
    CdkDragHandle,
  ],
  standalone: true,
})
export class RxListCaptureItemComponent implements OnInit {
  @Input()
  public id = 'item' + Math.random().toString(36).substring(2);

  @Input()
  public counter;

  @Input()
  public width;

  @Input()
  public height;

  @Input()
  public image: string;

  @Input()
  public showMenuHandle = true;

  @Input()
  public actionMenu: any;

  @Input()
  public actionMenuContext: any;

  @Input()
  public disableMenu = false;

  @Input()
  public disableCheckbox = false;

  @Input()
  public description;

  @Output()
  public checkedChange = new EventEmitter<boolean>();

  @Input()
  public set checked(val) {
    if (this._checked === !!val) {
      return;
    }
    this._checked = !!val;
    this._cd.detectChanges();
  }

  public get checked() {
    return this._checked;
  }

  protected _checked = false;

  constructor(private _cd: ChangeDetectorRef) {}

  ngOnInit() {}

  public checkedChanged() {
    if (!this.disableCheckbox) {
      this._checked = !this._checked;
    }
    this.checkedChange.emit(this._checked);
  }

  public onMenuClicked($event) {
    $event.preventDefault();
    $event.stopPropagation();
  }
}
